var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKabelHausanschluss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 215,
    viewBox: "0 0 195 215",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.15746 138.23C2.9569 137.549 1.43085 137.969 0.748923 139.17C0.0669988 140.37 0.487436 141.896 1.688 142.578L4.15746 138.23ZM128.877 211.947L127.642 214.121C128.405 214.554 129.339 214.556 130.103 214.125L128.877 211.947ZM191.674 176.597L192.901 178.776C193.684 178.335 194.17 177.507 194.174 176.608C194.178 175.708 193.698 174.876 192.919 174.429L191.674 176.597ZM28.8939 83.1843L27.6276 81.0287C26.8594 81.48 26.3894 82.3061 26.394 83.197C26.3985 84.088 26.8768 84.9092 27.6496 85.3527L28.8939 83.1843ZM166.43 5.28962C167.62 4.59027 168.019 3.05825 167.319 1.86776C166.62 0.67726 165.088 0.279104 163.897 0.978449L166.43 5.28962ZM1.688 142.578L127.642 214.121L130.111 209.773L4.15746 138.23L1.688 142.578ZM130.103 214.125L192.901 178.776L190.448 174.419L127.65 209.768L130.103 214.125ZM192.919 174.429L30.1382 81.016L27.6496 85.3527L190.43 178.766L192.919 174.429ZM30.1602 85.3399L166.43 5.28962L163.897 0.978449L27.6276 81.0287L30.1602 85.3399Z",
    fill: "#b4005f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKabelHausanschluss);
export default __webpack_public_path__ + "static/media/Kabel-Hausanschluss.811db341a1ef4a3e0e1d3cf82f0b73bf.svg";
export { ForwardRef as ReactComponent };